import React, { FC } from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';
import s from './WhatYouLearnAngular.scss';
import { ILPWhatYouLearnAngularData } from '../../../../../api/private/learn-engine-api/landing-page-api.interface';
import { i18n } from '../../../../../symphony';

type Props = {
	data: ILPWhatYouLearnAngularData;
	alias: string;
};

export const WhatYouLearnAngular: FC<Props> = ({ data, alias }) => {
	useStyles(s);
	return (
		<div className="what-you-learn">
			<div className="what-you-learn__container">
				<div className="what-you-learn__content">
					<h4 className="what-you-learn__title">
						{i18n.t(`web-lelp.${alias}-what-you-learn-title`)}
					</h4>
					<p className="what-you-learn__description">
						{i18n.t(`web-lelp.${alias}-what-you-learn-description`)}
					</p>
					<div className="what-you-learn__items-container">
						{data.items.map((item, index) => (
							<div
								className="what-you-learn__item"
								key={item.title}
							>
								<span className="what-you-learn__item-title">
									{i18n.t(
										`web-lelp.${alias}-what-you-learn-item${index}-title`,
									)}
								</span>
							</div>
						))}
					</div>
				</div>
				<div className="what-you-learn__image-container">
					<img
						className="what-you-learn__image"
						src={data.imgUrl}
						alt=""
					/>
				</div>
			</div>
		</div>
	);
};
